import { IReportSet } from '../../state/types';
import { makeFetchReportSet } from './_shared/fetchMakers';
import { normalizeAndTranslateSingleEntity } from './_shared/normalizers';
import { makeReportSetUrl } from './_shared/urlMakers';

export const fetchReportSet = makeFetchReportSet<IReportSet>(
    makeReportSetUrl,
    normalizeAndTranslateSingleEntity
);
